import { useEffect } from 'react';

/**
 * Mark a public, token-bearing page as never indexed while it is mounted
 * (shared Study reports, family-link invites). Restores the previous robots
 * value on unmount.
 */
export function useNoIndex() {
  useEffect(() => {
    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const created = !robots;
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    const previous = robots.content;
    robots.content = 'noindex,nofollow,noarchive';
    return () => {
      if (!robots) return;
      if (created) robots.remove();
      else robots.content = previous;
    };
  }, []);
}
